import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  TextField
} from '@mui/material';

import { setTheme } from '../../../store/slices/ideaSubmissionSlice';
import FormContainer from '../../../common/FormContainer/FormContainer';
import Button from '../../../common/Button/Button';
import './ChooseThemeStep.css';

export function ChooseThemeStep({ onNext, labels, themes }) {
  const dispatch = useDispatch();

  const reduxTheme = useSelector(
    (state) => state.ideaSubmission.theme
  );

  const [selectedThemeId, setSelectedThemeId] = useState(
    reduxTheme?.themeId || ''
  );
  const [customTheme, setCustomTheme] = useState(
    reduxTheme?.customTheme || ''
  );

  useEffect(() => {
    setSelectedThemeId(reduxTheme?.themeId || '');
    setCustomTheme(reduxTheme?.customTheme || '');
  }, [reduxTheme]);

  if (!themes || themes.length === 0) {
    return (
      <FormContainer>
        <div className="text-center">Loading themes…</div>
      </FormContainer>
    );
  }

  const selectedTheme = themes.find(
    (t) => t.id === selectedThemeId
  );

  const handleNext = () => {
    if (!selectedThemeId) return;

   dispatch(
  setTheme({
    themeId: selectedThemeId,
    themeTitle:
      selectedThemeId === 'other'
        ? customTheme
        : selectedTheme?.title || '',
    customTheme:
      selectedThemeId === 'other' ? customTheme : ''
  })
);


    onNext();
  };

  const isNextDisabled =
    !selectedThemeId ||
    (selectedThemeId === 'other' && !customTheme.trim());

  return (
    <FormContainer>
      {/* Header */}
      <header className="header">
        <div className="heading">{labels.title}</div>
        <div className="subHeading">{labels.subHeading}</div>
      </header>

      {/* Theme Dropdown */}
     {/* Theme Dropdown */}
<div className="select-wrapper">
  <FormControl
    fullWidth
    sx={{
      width: 420,
      mb: 3,
      backgroundColor: 'rgba(255, 255, 255, 0.9)',
      borderRadius: '14px',
      boxShadow: '0 10px 25px rgba(30, 60, 120, 0.12)',
    }}
  >
    <InputLabel
      id="theme-select-label"
      sx={{ color: '#5b6b8c' }}
    >
      Select Theme
    </InputLabel>

    <Select
      labelId="theme-select-label"
      label="Select Theme"
      value={selectedThemeId}
      sx={{
        borderRadius: '14px',
        '& fieldset': {
          borderColor: '#c7d7f0',
        },
        '&:hover fieldset': {
          borderColor: '#7aa2f7',
        },
        '&.Mui-focused fieldset': {
          borderColor: '#3b82f6',
        },
      }}
      onChange={(e) => {
        setSelectedThemeId(e.target.value);
        if (e.target.value !== 'other') {
          setCustomTheme('');
        }
      }}
    >
      {themes.map((theme) => (
        <MenuItem key={theme.id} value={theme.id}>
          {theme.title}
        </MenuItem>
      ))}
    </Select>
  </FormControl>
</div>

      {/* Theme Details */}
      {selectedTheme && selectedTheme.id !== 'other' && (
        <div className="theme-details">
          <p className="theme-title">
            {selectedTheme.caption}
          </p>
          {selectedTheme.subCaption && (
            <p className="theme-subtitle">
              {selectedTheme.subCaption}
            </p>
          )}
        </div>
      )}

      {/* Custom Theme Input */}
    {selectedThemeId === 'other' && (
  <div className="select-wrapper">
    <TextField
      sx={{
        width: 420,
        mb: 3,
        backgroundColor: 'rgba(255, 255, 255, 0.9)',
        borderRadius: '14px',
        boxShadow: '0 10px 25px rgba(30, 60, 120, 0.12)',
      }}
      label="Please describe your theme"
      placeholder="Enter your theme"
      value={customTheme}
      onChange={(e) => setCustomTheme(e.target.value)}
    />
  </div>
)}


      {/* Actions */}
      <div className="actions">
        <Button
          className="next-btn"
          onClick={handleNext}
          disabled={isNextDisabled}
        >
          Next
        </Button>
      </div>
    </FormContainer>
  );
}
